// extracted by mini-css-extract-plugin
module.exports = {"greyBoxWithIcon":"Home_greyBoxWithIcon__1FVgY"};